import React from "react";
import LanguageProvider from "./languages/LanguageProvider";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import theme from "../assets/styles/theme";
import { ThemeProvider } from "@material-ui/styles";
import { BrowserRouter as Router } from "react-router-dom";
import { Routes } from "./Routes";
import PermissionsProvider from "./shared/hooks/permissions/PermissionsProvider";

import "../assets/styles/global.css";
import "../../node_modules/react-grid-layout/css/styles.css";
import "../../node_modules/react-resizable/css/styles.css";

const App = (props) => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
          <PermissionsProvider>
            <LanguageProvider>
              <Router>
                <Routes />
              </Router>
            </LanguageProvider>
          </PermissionsProvider>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
